import { api } from "lib";

export const getStmRoleAdmin = async (params = {}) => {
    return await api.post("v1/stmRoleAdmin/getStmRoleAdminPagination", params);
};

export const updateAdminStatusFlag = async (params = {}) => {
    return await api.post("v1/stmRoleAdmin/updateStmRoleAdminStatusFlag", params);
};

export const updateStmRoleAdmin = async (params = {}) => {
    return await api.post("v1/stmRoleAdmin/updateStmRoleAdmin", params);
};